import { cn } from "@devhop/ui";
import { Banknote, Gift } from "lucide-react";

export type RoomBookingChargeType = "free" | "paid";

type RoomBookingChargeTypeRadioProps = {
  value: RoomBookingChargeType;
  onChange: (value: RoomBookingChargeType) => void;
  onBlur?: () => void;
  name?: string;
  disabled?: boolean;
  label?: string;
};

export function RoomBookingChargeTypeRadio({
  value,
  onChange,
  onBlur,
  name = "chargeType",
  disabled = false,
  label = "ຄິດເງິນຫຼືບໍ່",
}: RoomBookingChargeTypeRadioProps) {
  return (
    <fieldset className="min-w-0 border-0 p-0">
      <legend className="mb-2 font-medium text-sm">{label}</legend>
      <div className="grid gap-3 sm:grid-cols-2">
        <label
          className={cn(
            "flex cursor-pointer gap-3 rounded-lg border p-4 text-left ring-offset-background transition-colors focus-within:outline-none focus-within:ring-2 focus-within:ring-red-600 focus-within:ring-offset-2",
            disabled && "cursor-not-allowed opacity-60",
            value === "free"
              ? "border-red-600 bg-muted/50"
              : "border-border hover:bg-muted/30",
          )}
        >
          <input
            type="radio"
            name={name}
            value="free"
            checked={value === "free"}
            disabled={disabled}
            onChange={() => onChange("free")}
            onBlur={onBlur}
            className="sr-only"
          />
          <Gift
            className={cn(
              "mt-0.5 size-5 shrink-0 stroke-[1.5]",
              value === "free" ? "text-red-600" : "text-muted-foreground",
            )}
            aria-hidden
          />
          <span className="min-w-0 space-y-1">
            <span className="block font-semibold text-sm leading-tight">
              ບໍ່ຄິດເງິນ
            </span>
            <span className="block text-muted-foreground text-xs leading-snug">
              ຈອງໂດຍບໍ່ຄິດເງິນ ຫຼື ບໍ່ສ້າງໃບ
            </span>
          </span>
        </label>
        <label
          className={cn(
            "flex cursor-pointer gap-3 rounded-lg border p-4 text-left ring-offset-background transition-colors focus-within:outline-none focus-within:ring-2 focus-within:ring-red-600 focus-within:ring-offset-2",
            disabled && "cursor-not-allowed opacity-60",
            value === "paid"
              ? "border-red-600 bg-muted/50"
              : "border-border hover:bg-muted/30",
          )}
        >
          <input
            type="radio"
            name={name}
            value="paid"
            checked={value === "paid"}
            disabled={disabled}
            onChange={() => onChange("paid")}
            onBlur={onBlur}
            className="sr-only"
          />
          <Banknote
            className={cn(
              "mt-0.5 size-5 shrink-0 stroke-[1.5]",
              value === "paid" ? "text-red-600" : "text-muted-foreground",
            )}
            aria-hidden
          />
          <span className="min-w-0 space-y-1">
            <span className="block font-semibold text-sm leading-tight">
              ຄິດເງິນ (ເຊົ່າຫ້ອງ)
            </span>
            <span className="block text-muted-foreground text-xs leading-snug">
              ຄິດເງິນຕາມລາຄາເຊົ່າຫ້ອງ
            </span>
          </span>
        </label>
      </div>
    </fieldset>
  );
}
